import {Root} from '@radix-ui/react-progress';
import clsx from 'clsx';

type Props = React.ComponentProps<typeof Root>;
export function Progress(props: Props): React.JSX.Element {
  const className = clsx('relative overflow-hidden', props.className);

  return (
    <Root
      {...props}
      className={className}
      style={{
        // Fix overflow clipping in Safari
        // https://gist.github.com/domske/b66047671c780a238b51c51ffde8d3a0
        transform: 'translateZ(0)',
      }}
    >
      {props.children}
    </Root>
  );
}

Progress.displayName = 'Progress';
